import type { DreamityMainCategoryResDto, DreamitySubCategoryResDto } from '@/store/types/category.types'

/** 서버 마스터 없이 프론트에서만 사용하는 기본 카테고리 */
export function getStaticMainCategories(language: string): DreamityMainCategoryResDto[] {
  if (language === 'en') {
    return [
      { id: 1, mainCategoryCode: 'GROWTH', mainCategoryName: 'Growth' },
      { id: 2, mainCategoryCode: 'HEALTH', mainCategoryName: 'Health' },
      { id: 3, mainCategoryCode: 'RELATION', mainCategoryName: 'Relationships' },
      { id: 4, mainCategoryCode: 'CAREER', mainCategoryName: 'Career' },
      { id: 5, mainCategoryCode: 'FINANCE', mainCategoryName: 'Finance' },
      { id: 6, mainCategoryCode: 'FUN', mainCategoryName: 'Fun & Hobby' },
    ]
  }
  return [
    { id: 1, mainCategoryCode: 'GROWTH', mainCategoryName: '성장' },
    { id: 2, mainCategoryCode: 'HEALTH', mainCategoryName: '건강' },
    { id: 3, mainCategoryCode: 'RELATION', mainCategoryName: '관계' },
    { id: 4, mainCategoryCode: 'CAREER', mainCategoryName: '커리어' },
    { id: 5, mainCategoryCode: 'FINANCE', mainCategoryName: '재정' },
    { id: 6, mainCategoryCode: 'FUN', mainCategoryName: '취미·여가' },
  ]
}

export function getStaticSubCategories(language: string): DreamitySubCategoryResDto[] {
  if (language === 'en') {
    return [
      { id: 101, mainCategoryId: 1, subCategoryCode: 'STUDY', subCategoryName: 'Study' },
      { id: 102, mainCategoryId: 1, subCategoryCode: 'SKILL', subCategoryName: 'Skills' },
      { id: 201, mainCategoryId: 2, subCategoryCode: 'FITNESS', subCategoryName: 'Fitness' },
      { id: 202, mainCategoryId: 2, subCategoryCode: 'SLEEP', subCategoryName: 'Sleep' },
      { id: 301, mainCategoryId: 3, subCategoryCode: 'FAMILY', subCategoryName: 'Family' },
      { id: 302, mainCategoryId: 3, subCategoryCode: 'FRIENDS', subCategoryName: 'Friends' },
      { id: 401, mainCategoryId: 4, subCategoryCode: 'JOB', subCategoryName: 'Job' },
      { id: 501, mainCategoryId: 5, subCategoryCode: 'SAVE', subCategoryName: 'Savings' },
      { id: 601, mainCategoryId: 6, subCategoryCode: 'TRAVEL', subCategoryName: 'Travel' },
    ]
  }
  return [
    { id: 101, mainCategoryId: 1, subCategoryCode: 'STUDY', subCategoryName: '학습' },
    { id: 102, mainCategoryId: 1, subCategoryCode: 'SKILL', subCategoryName: '기술·자격' },
    { id: 201, mainCategoryId: 2, subCategoryCode: 'FITNESS', subCategoryName: '운동' },
    { id: 202, mainCategoryId: 2, subCategoryCode: 'SLEEP', subCategoryName: '수면' },
    { id: 301, mainCategoryId: 3, subCategoryCode: 'FAMILY', subCategoryName: '가족' },
    { id: 302, mainCategoryId: 3, subCategoryCode: 'FRIENDS', subCategoryName: '친구' },
    { id: 401, mainCategoryId: 4, subCategoryCode: 'JOB', subCategoryName: '업무' },
    { id: 501, mainCategoryId: 5, subCategoryCode: 'SAVE', subCategoryName: '저축' },
    { id: 601, mainCategoryId: 6, subCategoryCode: 'TRAVEL', subCategoryName: '여행' },
  ]
}
